import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';
import { CustomDropdown } from '../../../../../common/custom-form/custom-dropdown.component';
import { InputFieldFloatingLabel as InputField, SelectFieldFloatingLabel as Select } from '../../../../../common/custom-form/select-filter.component';
import { MAX_LENGTH } from '../../../../../../constants/external-constants';
import DATEPICKER_OR from "../../../../../common/custom-form/custom-date-picker.component";
import { TabberButton } from '../../../../../common/custom-form/tabber-button.component';
import { orderDetailsActions } from '../../../../../../store/external/order/order-details.reducer';
import CustomSearchableDropdownWrapper from "../../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";

class OrderLocationDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDropDown: false
        };
    }
    handleToggle = () => {
        this.setState(prev => ({ isDropDown: !prev.isDropDown }));
    }
    onChangeCountry = (propsName, value) => {
        this.props.FormChange(propsName, value)
        this.props.selectCountry(propsName, value);
    }
    onChangeDeliveryAddress = (propsName, value) => {
        const { orderDetailsForm, FormChange } = this.props;
        if (orderDetailsForm.countryCode && (value === null || value === undefined || value === '')) {
            FormChange(propsName, null);
        } else {
            FormChange(propsName, value);
            this.props.setDeliveryAddress(value);
        }
    }
    render() {        
        const { isDropDown } = this.state;
        const { translator, orderDetails, orderDetailsForm, disabled } = this.props;
        const baseDeliveryOptions = orderDetails.locationDeliveryAddressDropdown || [];
        const { deliveryAddressId, deliveryAddress, preferredDeliveryAddress } = orderDetailsForm;

        const isOtherSelected = deliveryAddressId === -1 && preferredDeliveryAddress;

        let deliveryAddressOptions = [...baseDeliveryOptions];
       
        if (isOtherSelected && !deliveryAddressOptions.some(opt => opt.Key === -1)) {
            deliveryAddressOptions = [{ Key: -1, Value: translator("other") }, ...deliveryAddressOptions];
        }
        
        const selectedExists = deliveryAddressOptions.some(
            opt => String(opt.Key) === String(deliveryAddressId)
        );

        if (
            deliveryAddressId != null &&
            deliveryAddressId !== -1 &&
            deliveryAddress &&
            !selectedExists
        ) {
            deliveryAddressOptions = [
                { Key: deliveryAddressId, Value: deliveryAddress },
                ...deliveryAddressOptions
            ];
        }
       
        return (
            <div className="control-container">
            <CustomDropdown activeDropdown={isDropDown} toggleActiveState={() => this.handleToggle()} label={translator("location_details")} >
            <div className={`add-sim-container detail-page-container`}>

                <div className="approver-details-row">
                
                <div className="date-picker-main-container">
                    <DATEPICKER_OR
                        label={translator("order_need_by_date")}
                        dateOnly={true}
                        startDate={orderDetailsForm.needByDate}
                        selectedDate={(date) => this.props.FormChange("orderDetailsForm.needByDate", date)}
                        placeholder={``}
                        isDisable={disabled}
                    />
                </div>
                <CustomSearchableDropdownWrapper
                    label={translator("country")}
                    options={orderDetails.locationCountryDropdown}
                    selected={orderDetailsForm.countryCode}
                    onChange={(e) => this.onChangeCountry('orderDetailsForm.countryCode', e)}
                    requiredField
                    isNullable={true}
                    placeholder={`${translator('select_placeholder')}`}
                    fieldProp='orderDetailsForm.countryCode'
                    tagName='countryCode'
                    disabled={disabled}
                    optionLabelKey={{
                        Key: 'Key',
                        Value: 'Value'
                    }}
                    maxLength={MAX_LENGTH.limit_100}
                    onSearchChange={this.props.handleCountrySearch} 
                    onLoadMore={this.props.loadMoreCountry}       
                    isLoading={orderDetails.isCountryLoading} 
                    hasMore={orderDetails.hasMoreCountry}  
                />
                    <div className="tabber-form-container">
                        <TabberButton 
                            title={translator("order_fixed_location")} 
                            onToggle={(isActive) => this.props.FormChange("orderDetailsForm.fixedLocation", isActive)}  
                            value={orderDetailsForm.fixedLocation}
                            disabled={disabled}
                        />
                    </div>
                </div>
                <div className="location-details-col-one">
                <CustomSearchableDropdownWrapper
                    label={translator("delivery_address")}
                    options={deliveryAddressOptions}
                    selected={orderDetailsForm.deliveryAddressId}
                    onChange={(e) => this.onChangeDeliveryAddress("orderDetailsForm.deliveryAddressId", e)}
                    placeholder={`${translator('select_placeholder')}`}
                    fieldProp='orderDetailsForm.deliveryAddressId'
                    tagName='.deliveryAddressId'
                    isNullable={true}
                    disabled={disabled}
                    optionLabelKey={{ Key: 'Key', Value: 'Value' }}
                    maxLength={MAX_LENGTH.limit_500}
                    onSearchChange={this.props.handleDeliveryAddressSearch}
                    onLoadMore={this.props.loadMoreDeliveryAddress}
                    isLoading={orderDetails.isDeliveryAddressLoading}
                    hasMore={orderDetails.hasMoreDeliveryAddress}
                />
                    <InputField
                        className="form-control"
                        type="text"
                        label={translator("preferred_delivery_address")}
                        value={orderDetailsForm.preferredDeliveryAddress}
                        fieldProp='orderDetailsForm.preferredDeliveryAddress'
                        maxLength={MAX_LENGTH.limit_500}
                        disabled={disabled || orderDetailsForm.deliveryAddressId != -1}
                    />
                </div>
                
                 
            </div>
            </CustomDropdown>
            
        </div>
        );
    }
}

export default connect(
    state => {
        const { orderDetails, translation } = state;
        const { orderDetailsForm } = state.form;
        return {
            orderDetails,
            orderDetailsForm,
            ...translation
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, orderDetailsActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    }) 
)(OrderLocationDetails);